import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"
import MarketToMarket from "./market-to-market-content"
import { MARKET_TO_MARKET_CONTENT_SX } from "./constants"

const MarketToMarketTab = ({ company }) => (
    <Box sx={MARKET_TO_MARKET_CONTENT_SX}>
        <MarketToMarket empresa={company} />
    </Box>
)

MarketToMarketTab.propTypes = { company: PropTypes.object.isRequired }

export default MarketToMarketTab
